<template>
  <div class="home">
    <div class="tabledata">
      <el-table
        :data="tableData"
        border
      >
        <el-table-column
          prop="activityTitle"
          label="活动名称"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="订单数"
          :formatter="orderFormat"
          v-if="!channelFlag"
        >
        </el-table-column>
        <el-table-column
          prop="riskNum"
          label="风险订单数"
          :formatter="riskFormat"
        >
        </el-table-column>
        <el-table-column
          prop="riskRate"
          label="风险比例"
          :formatter="riskPerFormat"
          v-if="!channelFlag"
        >
        </el-table-column>
        <el-table-column
          prop="violateNum"
          label="违规订单数"
          :formatter="violateFormat"
        >
        </el-table-column>
        <el-table-column
          prop="violateRate"
          label="违规比例"
          :formatter="violatePerFormat"
          v-if="!channelFlag"
        >
        </el-table-column>
        <el-table-column
          prop="maxCreatedOn"
          label="更新时间"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="380"
        >
          <template slot-scope="scope">
            <div style="display:flex">
              <el-button
                type="success"
                class="handel"
                @click="getLgActivityRiskOrders(scope.row.activityId)"
              >查风险</el-button>
              <el-button
                type="primary"
                class="handel"
                @click="exportActivityRiskOrders(scope.row.activityId)"
                v-if="!channelFlag"
              >导风险</el-button>
              <el-button
                type="success"
                class="handel"
                @click="getLgActivityOrders(scope.row.activityId)"
              >查违规</el-button>
              <el-button
                type="primary"
                class="handel"
                @click="exportActivityOrders(scope.row.activityId)"
                v-if="!channelFlag"
              >导违规</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getLgActivity,
  exportActivityOrder,
  exportRiskActivityOrder
} from "@/api/activityorder";
import store from "@/store";
import router from "@/router";
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      channelFlag: ""
    };
  },
  mounted() {
    this.channelFlag = store.state.user.userInfo.userType >= 10 ? true : false;
    this.search();
  },

  methods: {
    orderFormat(row, column) {
      return row.validateCount == 0
        ? "未统计"
        : Number(row.validateCount) + Number(row.violateCount);
    },
    riskFormat(row, column) {
      return row.validateCount == 0 ? "未统计" : row.riskCount;
    },
    riskPerFormat(row, column) {
      return row.validateCount == 0
        ? "未统计"
        : Math.round(
            (Number(row.riskCount) * 100) /
              (Number(row.validateCount) + Number(row.riskCount))
          ) + "%";
    },
    violateFormat(row, column) {
      return row.validateCount == 0 ? "未统计" : row.violateCount;
    },
    violatePerFormat(row, column) {
      return row.validateCount == 0
        ? "未统计"
        : Math.round(
            (Number(row.violateCount) * 100) /
              (Number(row.validateCount) + Number(row.violateCount))
          ) + "%";
    },
    async exportActivityOrders(val) {
      this.loading = true;
      await exportActivityOrder({
        activityId: val
      }).then(res => {
        this.loading = false;
        if (res.code === 1000) {
          const link = document.createElement("a");
          link.href = res.data;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    async exportActivityRiskOrders(val) {
      this.loading = true;
      await exportRiskActivityOrder({
        activityId: val
      }).then(res => {
        this.loading = false;
        if (res.code === 1000) {
          const link = document.createElement("a");
          link.href = res.data;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    async search(val) {
      await getLgActivity({
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code == 1000) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search(); // 重新搜索以更新分页数据
    },
    getLgActivityOrders(val) {
      router.push({ path: `/lg/activityorders/${val}` });
    },
    getLgActivityRiskOrders(val) {
      router.push({ path: `/lg/activityriskorders/${val}` });
    }
  }
};
</script>

